import { useState } from 'react';

const ERROR_ACCESS_DENIED_IOS =
  'The operation couldn’t be completed. (kCLErrorDomain error 1.)'; // iOS
const ERROR_ACCESS_DENIED_ANDROID = 'User denied location permission'; // android
const ERROR_ACCESS_LOCATION_UNAVAILABLE_ANDROID = 'location unavailable'; // android
const ERROR_ACCESS_DENIED_WEB = 'User denied Geolocation'; // web

const ERROR_VERIFY_LOCATION_PERMISSIONS =
  'Please verify if your location preferences are switched ON';

export function useGeolocation() {
  const [currentPosition, setCurrentPosition] = useState();
  const [errorMessage, setErrorMessage] = useState<any>({});

  /* Commented Code as SetInterval is not flow is not working in iOS. */

  const watchCurrentPosition = () => {
  };


  return {
    watchCurrentPosition,
    currentPosition,
    errorMessage
  };
}
